import { Table } from "@/features/Table";
import { type ProviderConfig, provider_configs_columns } from "./columns";
import {
  type FilterProviderConfigsSchema,
  FilterProviderConfigs,
} from "./filter";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const client = "etl-quantilia";
const table_name = "provider_configs";

export const ProviderConfigsTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;
  const { t } = useTranslation();

  return (
    <Table<ProviderConfig, FilterProviderConfigsSchema>
      label={t(`${table_name}.title`, {
        ns: "tables",
        defaultValue: "Provider Configurations",
      })}
      client={client}
      table_name={table_name}
      columns={provider_configs_columns}
      filter={<FilterProviderConfigs />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
